import React, { useState, useEffect } from 'react';
import { useParams} from 'react-router-dom';
import PropTypes from 'prop-types';
import API from 'config/ApiConfig';

export default function UpdateTentor() {
  const [formData, setFormData] = useState({
    nama: '',
    email: '',
    alamat: '',
    telepon: '',
    ngaji: '',
    kemampuan: '',
    pendidikan: '',
    pengalaman: '',
    ketersediaan: [],
    user_id: ''
  });
  const [errors, setErrors] = useState({});
  const [users, setUsers] = useState([]);
  const [fetchError, setFetchError] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  const { userId } = useParams(); // Ambil userId dari rute
  // const API_BASE_URL = 'http://localhost:5000/api/admin';
  const API_BASE_URL = API.API_ADMIN
  const JWT_TOKEN = localStorage.getItem('authToken');

  function getAuthHeaders() {
    return {
      'Authorization': `Bearer ${JWT_TOKEN}`,
      'Content-Type': 'application/json',
    };
  }

  useEffect(() => {
    const fetchTentor = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/tentor/${userId}`, {
          headers: getAuthHeaders(),
        });
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        setFormData(data);
      } catch (error) {
        console.error('Error fetching tentor details:', error);
        setFetchError('Failed to fetch tentor details.');
      }
    };

    const fetchUsers = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/user`, {
          headers: getAuthHeaders(),
        });
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        setUsers(data);
      } catch (error) {
        console.error('Error fetching users:', error);
        setFetchError('Failed to fetch users.');
      }
    };

    fetchTentor();
    fetchUsers();
  }, [userId]);

  const validate = () => {
    const errors = {};
    if (!formData.user_id) errors.user_id = 'User is required';
    if (!formData.nama) errors.nama = 'Nama is required';
    if (!formData.email) errors.email = 'Email is required';
    if (!formData.telepon) errors.telepon = 'Telepon is required';
    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validate()) {
      setIsSubmitting(true);
      // Ensure the fields are strings and split them if necessary
      const kemampuan = typeof formData.kemampuan === 'string' ? formData.kemampuan.split(',').map(item => item.trim()).filter(item => item !== '') : formData.kemampuan.join(', ').split(',').map(item => item.trim()).filter(item => item !== '') ;
      console.log("error di" + kemampuan)
      const dataToSubmit = {
        ...formData,
        kemampuan,
      };
  
      try {
        const response = await fetch(`${API_BASE_URL}/tentor/${userId}`, {
          method: 'PUT',
          headers: getAuthHeaders(),
          body: JSON.stringify(dataToSubmit),
        });
  
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
  
        const data = await response.json();
        // Optionally redirect or show success message
        alert('Data Tentor berhasil diperbarui');
      } catch (error) {
        console.error('Error updating tentor:', error);
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  const handleKetersediaanChange = (event, index) => {
    const { name, value } = event.target;
    const newKetersediaan = [...formData.ketersediaan];
    newKetersediaan[index] = { ...newKetersediaan[index], [name]: value };
    setFormData(prevState => ({
      ...prevState,
      ketersediaan: newKetersediaan
    }));
  };

  const addKetersediaanField = () => {
    setFormData(prevState => ({
      ...prevState,
      ketersediaan: [...prevState.ketersediaan, { hari: '', waktu_mulai: '', waktu_selesai: '' }]
    }));
  };

  const removeKetersediaanField = (index) => {
    setFormData(prevState => ({
      ...prevState,
      ketersediaan: prevState.ketersediaan.filter((_, i) => i !== index)
    }));
  };

  if (fetchError) {
    return <p className="text-red-500 text-xs">{fetchError}</p>;
  }
  const handleClick = () =>{
    alert("Berhasil Mengupdate Data Tentor");
    window.location.href="/admin/tentor"
    
  }

  return (
    <div>
      <h3 className="font-bold uppercase text-lg text-blueGray-700 align-center m-4">Update Tentor</h3>
      <form onSubmit={handleSubmit} className="space-y-2">
        {/* Dropdown untuk memilih user */}
        <div>
          <span className="z-10 h-full leading-snug font-normal absolute text-center text-blueGray-300 absolute bg-transparent rounded text-base items-center justify-center w-8 pl-3 py-3">
            <i className="fas fa-user"></i>
          </span>
          <select
            name="user_id"
            value={formData.user_id}
            onChange={(e) => setFormData({ ...formData, user_id: e.target.value })}
            className="mb-4 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm border border-blueGray-300 outline-none focus:outline-none focus:shadow-outline w-full pl-10"
          >
            <option value="">Pilih User</option>
            {users.map(user => (
              <option key={user._id} value={user._id}>
                {user.username}
              </option>
            ))}
          </select>
          {errors.user_id && <p className="text-red-500 text-xs">{errors.user_id}</p>}
        </div>

        {/* Input fields for tentor details */}
        <div>
          <span className="z-10 h-full leading-snug font-normal absolute text-center text-blueGray-300 absolute bg-transparent rounded text-base items-center justify-center w-8 pl-3 py-3">
            <i className="fas fa-user"></i>
          </span>
          <input
            type="text"
            name="nama"
            value={formData.nama}
            onChange={(e) => setFormData({ ...formData, nama: e.target.value })}
            placeholder="Nama"
            className="mb-4 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm border border-blueGray-300 outline-none focus:outline-none focus:shadow-outline w-full pl-10"
          />
          {errors.nama && <p className="text-red-500 text-xs">{errors.nama}</p>}
        </div>

        <div>
          <span className="z-10 h-full leading-snug font-normal absolute text-center text-blueGray-300 absolute bg-transparent rounded text-base items-center justify-center w-8 pl-3 py-3">
            <i className="fas fa-envelope"></i>
          </span>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
            placeholder="Email"
            className="mb-4 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm border border-blueGray-300 outline-none focus:outline-none focus:shadow-outline w-full pl-10"
          />
          {errors.email && <p className="text-red-500 text-xs">{errors.email}</p>}
        </div>

        <div>
          <span className="z-10 h-full leading-snug font-normal absolute text-center text-blueGray-300 absolute bg-transparent rounded text-base items-center justify-center w-8 pl-3 py-3">
            <i className="fas fa-home"></i>
          </span>
          <input
            type="text"
            name="alamat"
            value={formData.alamat}
            onChange={(e) => setFormData({ ...formData, alamat: e.target.value })}
            placeholder="Alamat"
            className="mb-4 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm border border-blueGray-300 outline-none focus:outline-none focus:shadow-outline w-full pl-10"
          />
        </div>

        <div>
          <span className="z-10 h-full leading-snug font-normal absolute text-center text-blueGray-300 absolute bg-transparent rounded text-base items-center justify-center w-8 pl-3 py-3">
            <i className="fas fa-phone"></i>
          </span>
          <input
            type="text"
            name="telepon"
            value={formData.telepon}
            onChange={(e) => setFormData({ ...formData, telepon: e.target.value })}
            placeholder="Telepon"
            className="mb-4 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm border border-blueGray-300 outline-none focus:outline-none focus:shadow-outline w-full pl-10"
          />
          {errors.telepon && <p className="text-red-500 text-xs">{errors.telepon}</p>}
        </div>

        <div>
          <span className="z-10 h-full leading-snug font-normal absolute text-center text-blueGray-300 absolute bg-transparent rounded text-base items-center justify-center w-8 pl-3 py-3">
            <i className="fas fa-book"></i>
          </span>
          <input
            type="text"
            name="ngaji"
            value={formData.ngaji}
            onChange={(e) => setFormData({ ...formData, ngaji: e.target.value })}
            placeholder="Ngaji"
            className="mb-4 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm border border-blueGray-300 outline-none focus:outline-none focus:shadow-outline w-full pl-10"
          />
        </div>

        <div>
          <span className="z-10 h-full leading-snug font-normal absolute text-center text-blueGray-300 absolute bg-transparent rounded text-base items-center justify-center w-8 pl-3 py-3">
            <i className="fas fa-cogs"></i>
          </span>
          <input
            type="text"
            name="kemampuan"
            value={formData.kemampuan}
            onChange={(e) => setFormData({ ...formData, kemampuan: e.target.value })}
            placeholder="Kemampuan (pisahkan dengan koma)"
            className="mb-4 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm border border-blueGray-300 outline-none focus:outline-none focus:shadow-outline w-full pl-10"
          />
        </div>

        <div>
          <span className="z-10 h-full leading-snug font-normal absolute text-center text-blueGray-300 absolute bg-transparent rounded text-base items-center justify-center w-8 pl-3 py-3">
            <i className="fas fa-graduation-cap"></i>
          </span>
          <input
            type="text"
            name="pendidikan"
            value={formData.pendidikan}
            onChange={(e) => setFormData({ ...formData, pendidikan: e.target.value })}
            placeholder="Pendidikan"
            className="mb-4 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm border border-blueGray-300 outline-none focus:outline-none focus:shadow-outline w-full pl-10"
          />
        </div>

        <div>
          <span className="z-10 h-full leading-snug font-normal absolute text-center text-blueGray-300 absolute bg-transparent rounded text-base items-center justify-center w-8 pl-3 py-3">
            <i className="fas fa-bookmark"></i>
          </span>
          <input
            type="text"
            name="pengalaman"
            value={formData.pengalaman}
            onChange={(e) => setFormData({ ...formData, pengalaman: e.target.value })}
            placeholder="Pengalaman"
            className="mb-4 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm border border-blueGray-300 outline-none focus:outline-none focus:shadow-outline w-full pl-10"
          />
        </div>

        {/* Ketersediaan */}
        <div>
          <h4 className="font-semibold text-blueGray-600">Ketersediaan:</h4>
          {formData.ketersediaan.map((item, index) => (
            <div key={index} className="mb-4 p-4 border border-blueGray-300 rounded bg-white">
              <div>
                <label className="text-blueGray-600">Hari:</label>
                <input
                  type="text"
                  name="hari"
                  value={item.hari}
                  onChange={(e) => handleKetersediaanChange(e, index)}
                  placeholder="Hari"
                  className="mb-2 px-3 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm border border-blueGray-300 outline-none focus:outline-none focus:shadow-outline w-full"
                />
              </div>
              <div>
                <label className="text-blueGray-600">Waktu Mulai:</label>
                <input
                  type="text"
                  name="waktu_mulai"
                  value={item.waktu_mulai}
                  onChange={(e) => handleKetersediaanChange(e, index)}
                  placeholder="Waktu Mulai"
                  className="mb-2 px-3 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm border border-blueGray-300 outline-none focus:outline-none focus:shadow-outline w-full"
                />
              </div>
              <div>
                <label className="text-blueGray-600">Waktu Selesai:</label>
                <input
                  type="text"
                  name="waktu_selesai"
                  value={item.waktu_selesai}
                  onChange={(e) => handleKetersediaanChange(e, index)}
                  placeholder="Waktu Selesai"
                  className="mb-2 px-3 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm border border-blueGray-300 outline-none focus:outline-none focus:shadow-outline w-full"
                />
              </div>
              <button
                type="button"
                onClick={() => removeKetersediaanField(index)}
                className="bg-red-500 text-white px-3 py-2 rounded"
              >
                Hapus
              </button>
            </div>
          ))}
          <button
            type="button"
            onClick={addKetersediaanField}
            className="bg-blue-500 text-white px-3 py-2 rounded"
          >
            Tambah Ketersediaan
          </button>
        </div>

        <div className="flex justify-between mt-4">
        <button
              type="submit"
              className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none m-4 ease-linear transition-all duration-150"
                onClick={handleClick}
            >
              Update Tentor
            </button>
          <a href={`/admin/tentor`}>
            <button
              type="button"
              className="bg-red-500 text-white px-4 py-2 rounded"
            >
              Batal
            </button>
          </a>
        </div>
      </form>
    </div>
  );
}

UpdateTentor.propTypes = {
  tentorId: PropTypes.string.isRequired,
};
